/**
 * Дефолтный публичный origin API (dev/stage). Править здесь и в vite.config.ts (proxy target).
 * Переопределение: `VITE_API_BASE_URL`. В локальном dev без env база API по умолчанию — этот origin (`getApiBaseUrl`).
 */
export const DEFAULT_PUBLIC_API_ORIGIN = "https://api.dev.leninka-ip.ru"

/** Пути приложения относительно origin (без завершающего слэша у origin). */
export const apiPaths = {
  connectToken: "/connect/token",
  authRegister: "/api/app/auth/register",
  authConfirmEmail: "/api/app/auth/confirm-email",
  authSendPasswordReset: "/api/app/auth/send-password-reset-link",
  authResetPassword: "/api/app/auth/reset-password",
  authChangePassword: "/api/app/auth/change-password",
  /** POST — анонимный пакет продуктовых событий без идентификаторов и PII. */
  productAnalyticsEvents: "/api/product-analytics/events",
  userProfileMy: "/api/app/user-profile/my-profile",
  /** GET — PDF профиля текущего пользователя (`DepositFileDownloadResult`). */
  userProfileMyPdf: "/api/app/user-profile/my-profile-pdf",
  /** GET: query eventId, userId — полный профиль участника (инициатор / модератор заявок). */
  userProfileFullForEventParticipant: "/api/app/user-profile/full-profile-for-event-participant",
  filesUpload: "/api/files/upload",
  applicationConfiguration: "/api/abp/application-configuration",
  educationLevels: "/api/app/education-lookup/levels",
  educationInstitutions: "/api/app/education-lookup/institutions",
  educationSpecialities: "/api/app/education-lookup/specialities",
  userEducation: "/api/app/user-education",
  languageLookupLanguages: "/api/app/language-lookup/languages",
  languageLookupLevels: "/api/app/language-lookup/levels",
  userLanguage: "/api/app/user-language",
  workIndustries: "/api/app/work-lookup/industries",
  workSearchSpecializations: "/api/app/work-lookup/search-specializations",
  userWorkExperience: "/api/app/user-work-experience",
  portfolioAchievement: "/api/app/portfolio-achievement",
  userAccount: "/api/app/user-account",
  userAssociation: "/api/app/user-association",
  groupKind: "/api/app/group-kind",
  group: "/api/app/group",
  specialization: "/api/app/specialization",
  projects: "/api/app/project",
  notifications: "/api/app/notification",
  notificationUnreadCount: "/api/app/notification/unread-count",
  notificationMarkRead: "/api/app/notification/{id}/mark-read",
  notificationMarkAllRead: "/api/app/notification/mark-all-read",
  notificationById: "/api/app/notification/{id}",
  notificationAllRead: "/api/app/notification/all-read",
  /** GET список; PUT обновление — тот же путь, см. Swagger: `type` в query. */
  notificationPreferences: "/api/app/notification-preference",
  notificationsStream: "/api/app/notifications/stream",
  identityRoles: "/api/identity/roles",
  identityRolesAll: "/api/identity/roles/all",
  identityUsers: "/api/identity/users",
  identityUsersAssignableRoles: "/api/identity/users/assignable-roles",
  permissionManagement: "/api/permission-management/permissions",
  creativeSelfDefinitionTaxonomy: "/api/app/creative-self-definition/creative-taxonomy",
  creativeSelfDefinitionMy: "/api/app/creative-self-definition/my-creative-self-definition",
  creativeSelfDefinitionSubmitSuggestion:
    "/api/app/creative-self-definition/submit-my-creative-role-suggestion",
  creativeSelfDefinitionSuggestionList: "/api/app/creative-self-definition/creative-role-suggestion-list",
  /** POST — создание типовой роли в каталоге (ManageCatalog) */
  creativeSelfDefinitionCreativeRoleDefinition: "/api/app/creative-self-definition/creative-role-definition",
} as const

/** POST — одобрение предложения; тело `ApproveCreativeRoleSuggestionDto` (опционально `description`) */
export const creativeSelfDefinitionApproveSuggestionPath = (id: string) =>
  `/api/app/creative-self-definition/${encodeURIComponent(id)}/approve-creative-role-suggestion`

/** POST с телом отклонения */
export const creativeSelfDefinitionRejectSuggestionPath = (id: string) =>
  `/api/app/creative-self-definition/${encodeURIComponent(id)}/reject-creative-role-suggestion`

/** PUT — обновление описания типовой роли; DELETE — soft-delete */
export const creativeSelfDefinitionCreativeRoleDefinitionByIdPath = (id: string) =>
  `/api/app/creative-self-definition/${encodeURIComponent(id)}/creative-role-definition`

export const getSwaggerUiUrl = (origin: string = DEFAULT_PUBLIC_API_ORIGIN) => {
  const base = origin.replace(/\/$/, "")
  return `${base}/swagger/index.html`
}
